export default class SelectView {
    constructor(json) {
        this.id = json.id;
        this.name = json.name;
    }
}
